<template>
  <t-default-layout ref="defaultLayout" active-nav-id="campaigns-category">
    <div id="t-campaigns-category-component" class="t-campaigns-category">
      <div class="t-campaigns-category-heading-line">
        <a-page-heading class="t-campaigns-category-heading-item">記事・セミナー（カテゴリ）</a-page-heading>
        <a-button
          v-if="isSuperUser"
          id="t-campaigns-category-add-button"
          data-testid="campaigns-category-add-button"
          class="t-campaigns-category-heading-item"
          variant="icon"
          color="primary"
          icon="plus"
          icon-color="white"
          @click="handleAdd"
        />
      </div>
      <m-section>
        <div class="t-campaigns-category-tabgroup">
          <m-action-card title="" icon="">
            <component
              :is="checkIsManager() ? 'm-data-table-services' : 'm-data-table'"
              ref="dataTable"
              id-text="t-campaigns-category-add-display"
              :empty-text="dataTableEmptyText"
              :fit="true"
              :data="displayedTableData()"
              :border="true"
              @position-update="handlePositionUpdate($event)"
            >
              <a-data-table-column prop="categoryName" label="カテゴリ名" align="left">
                <template #default="scope">
                  <a-text>
                    <span style="font-size: 15px; white-space: pre">
                      {{ scope.row.categoryName }}
                    </span>
                  </a-text>
                </template>
              </a-data-table-column>
              <a-data-table-column type="action" :width="160" align="right" class="a-data-table-column--action">
                <template #default="scope">
                  <a-button
                    v-if="isSuperUser"
                    :id="scope.row.documentId + '-deleteBtn'"
                    :data-testid="'campaigns-category-delete-button-' + scope.index"
                    variant="round"
                    size="small"
                    label="削除"
                    color="grey"
                    icon="trash"
                    icon-color="black"
                    :inline="true"
                    @click="handleConfirmDelete(scope.row)"
                  />
                </template>
              </a-data-table-column>
            </component>
          </m-action-card>
        </div>
      </m-section>
      <!-- モーダル 共有 -->
      <teleport to="body">
        <o-modal
          id="common-modal"
          :visible="modalVisible"
          class="o-modal--confirmation"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="false"
          @close="closeModal"
        >
          <template #title>{{ modalConfig.title }}</template>
          <a-text> <span id="t-campaigns-category-remove-modal-body" v-html="modalConfig.content" /></a-text>
          <template #footer>
            <a-button
              v-for="(action, index) in modalConfig.actions"
              :key="index"
              :variant="action.variant"
              :color="action.color"
              :label="action.label"
              size="small"
              :data-testid="action.dataTestId"
              @click="action.onClick"
            />
          </template>
        </o-modal>
      </teleport>
    </div>
  </t-default-layout>
</template>

<script>
import TDefaultLayout from '@/components/templates/default-layout';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AText from '@/components/atoms/text';
import AButton from '@/components/atoms/button';
import OModal from '@/components/organisms/modal';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-campaigns-category',
  components: {
    TDefaultLayout,
    APageHeading,
    MSection,
    MActionCard,
    AText,
    AButton,
    OModal
  },
  mixins: [customRequest, messageContent],
  data() {
    return {
      tableData: [],
      targetDocId: '',
      eventData: {},
      modalVisible: false,
      modalConfig: {
        id: 'common-modal',
        class: '',
        title: '',
        content: '',
        actions: [],
      },
      execUserID: this.$store.state.user.userID,
    };
  },
  computed: {
    isSuperUser() {
      return this.$store.state.user.authInfo === 'manager';
    },
  },
  created() {
    this.campaignsCategoryList();
  },
  methods: {
    checkIsManager() {
      return this.isSuperUser;
    },
    displayedTableData() {
      return this.tableData;
    },
    closeModal() {
      this.modalVisible = false;
      this.modalConfig = { id: 'common-modal', class: '', title: '', content: '', actions: [] };
      if (this.eventData && Object.keys(this.eventData).length > 0) {
        this.campaignsCategoryList();
        this.eventData = {};
      }
    },
    handlePositionUpdate(event) {
      // ユーザー権限をチェックする
      if (this.isSuperUser) {
        // ユーザーがマネージャーの場合にアクションを実行します
        this.eventData = event;
        this.modalVisible = true;
        this.modalConfig = {
          id: 't-campaigns-category-update-position-modal',
          class: 'o-modal--update-confirmation',
          title: 'Info',
          content: messageContent.updatePosition(event.newData.categoryName),
          actions: [
            { variant: 'outlined', color: 'primary', label: 'いいえ', onClick: this.closeUpdatePositionConfirmModal, dataTestId: 't-campaigns-category-position-update-modal-cancel-button' },
            { variant: 'block', color: 'primary', label: 'はい', onClick: () => this.positionUpdate(this.eventData), dataTestId: 't-campaigns-category-position-update-modal-confirm-button' },
          ],
        };
      }
    },
    positionUpdate(data) {
      const formData = {
        sourceDocumentID: data.newData.documentID,
        sourcePosition: data.newData.sortOrder,
        destinationDocumentID: data.oldData.documentID,
        destinationPosition: data.oldData.sortOrder,
        listCampaignsCategorySort: this.tableData.map(item => ({
          documentID: item.documentID,
          sortOrder: item.sortOrder,
        })),
      };
      this.postRequest('/campaigns-category/update-position', formData).then(res => {
        if (res.status === 'success') {
          this.closeModal();
          this.campaignsCategoryList();
          this.eventData = {};
        } else {
          this.closeModal();
          this.modalVisible = true;
          this.modalConfig = {
            id: 't-campaigns-category-update-result-modal',
            class: 'o-modal--result',
            title: 'エラー',
            content: res.message || 'カテゴリの位置更新に失敗しました。',
            actions: [{ variant: 'block', color: 'primary', label: 'OK', onClick: this.closeModal }],
          };
        }
      });
    },
    closeUpdatePositionConfirmModal() {
      this.modalVisible = false;
      this.modalConfig = { id: 'common-modal', class: '', title: '', content: '', actions: [] };
      if (this.eventData && Object.keys(this.eventData).length > 0) {
        this.campaignsCategoryList();
      }
    },
    handleConfirmDelete(row) {
      this.targetDocId = row.documentID;
      this.modalVisible = true;
      this.modalConfig = {
        id: 't-campaigns-category-delete-confirm-modal',
        class: 'o-modal--delete-confirmation',
        title: 'Info',
        content: messageContent.confirmDelete(row.categoryName),
        actions: [
          { variant: 'outlined', color: 'primary', label: 'いいえ', onClick: this.closeModal, dataTestId: 't-campaigns-category-delete-modal-cancel-button' },
          { variant: 'block', color: 'primary', label: 'はい', onClick: () => this.handleDelete(this.targetDocId), dataTestId: 't-campaigns-category-delete-modal-confirm-button' },
        ],
      };
    },
    async handleDelete(documentID) {
      this.closeModal();
      const formData = { execUserID: this.execUserID, documentID: documentID };
      try {
        const response = await this.postRequest('/campaigns-category/delete', formData);
        if (response.status === 'failed') {
          this.modalVisible = true;
          this.modalConfig = {
            id: 't-campaigns-category-delete-result-modal',
            class: 'o-modal--result',
            title: 'Info',
            content: response.error,
            actions: [{ variant: 'block', color: 'primary', label: 'OK', onClick: this.closeModal }],
          };
          return;
        }
        this.$router.push({ name: 'CampaignsCategory' }).then(() => {
          this.$router.go();
        });
      } catch (error) {
        this.modalVisible = true;
        this.modalConfig = {
          id: 't-campaigns-category-delete-result-modal',
          class: 'o-modal--result',
          title: 'エラー',
          content: `削除中にエラーが発生しました: ${error.message}`,
          actions: [{ variant: 'block', color: 'primary', label: 'OK', onClick: this.closeModal }],
        };
      }
    },
    campaignsCategoryList() {
      this.tableData = [];
      const data = { execUserID: this.execUserID };
      this.postRequest('/campaigns-category/get-list', data).then(e => {
        if (e && e.data) {
          this.tableData = Object.keys(e.data)
            .map(k => ({
              documentID: k,
              categoryName: e.data[k].categoryName,
              createUserName: e.data[k].createUserName,
              sortOrder: e.data[k].sortOrder,
            }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
        }
      });
    },
    handleAdd() {
      if (this.tableData.length >= 10) {
        this.modalVisible = true;
        this.modalConfig = {
          id: 't-campaigns-category-add-result-modal',
          class: 'o-modal--result',
          title: 'Info',
          content: 'カテゴリが10個より多く追加できません。',
          actions: [{ variant: 'block', color: 'primary', label: 'OK', onClick: this.closeModal }],
        };
        return;
      }
      this.$router.push({ path: '/campaigns-category/add', query: { execUserID: this.execUserID } });
    },
  },
};
</script>
